import { useState } from 'react';
import { Link } from 'react-router-dom';
import PageLayout from '../components/layout/PageLayout';
import IllustrationModal from '../components/modals/IllustrationModal';
import { useProjects } from '../hooks/useProjects';

const FILTERS = [
  { key: 'all',          label: 'All' },
  { key: 'uiux',         label: 'UIUX' },
  { key: 'illustration', label: 'Illustration' },
  { key: 'content',      label: 'Content' },
  { key: 'etc',          label: 'Etc' },
];

function WorkCard({ project, onOpenModal }) {
  const isDetailPage = project.type === 'uiux';

  const inner = (
    <div className="work-card">
      <div className="work-card__img">
        {project.images[0] && (
          <img src={project.images[0].src} alt={project.images[0].alt} loading="lazy" />
        )}
      </div>
      <h3 className="work-card__title">{project.title}</h3>
      <div className="work-card__meta">
        <div className="work-card__meta-left">
          <span className="work-card__year">{project.year}</span>
          <span className="work-card__type">{project.type === 'uiux' ? 'UI/UX' : project.type}</span>
        </div>
        <div className="work-card__tags work-card__tags--hidden">
          {project.tags.slice(0, 2).map((tag) => (
            <span key={tag} className="work-card__tag">{tag}</span>
          ))}
        </div>
      </div>
    </div>
  );

  return isDetailPage ? (
    <Link to={`/work/${project.id}`} className="work-card-link">{inner}</Link>
  ) : (
    <div onClick={() => onOpenModal(project)} style={{ display: 'block' }}>{inner}</div>
  );
}

export default function WorkPage() {
  const [filter, setFilter]     = useState('all');
  const [modalProject, setModalProject] = useState(null);
  const { projects, loading }   = useProjects(filter);

  return (
    <PageLayout>
      <div className="work-page">
        <div className="work-title-area">
          <h1 className="work-h1">Work</h1>
        </div>

        <div className="work-filter-bar">
          {FILTERS.map(({ key, label }) => (
            <button
              key={key}
              onClick={() => setFilter(key)}
              className={`work-filter-btn${filter === key ? ' work-filter-btn--active' : ''}`}
            >
              {label}
            </button>
          ))}
        </div>

        {loading ? (
          <p className="work-empty">Loading...</p>
        ) : projects.length > 0 ? (
          <div className="work-grid">
            {projects.map((project) => (
              <WorkCard key={project.id} project={project} onOpenModal={setModalProject} />
            ))}
          </div>
        ) : (
          <p className="work-empty">No projects yet.</p>
        )}
      </div>

      {modalProject && (
        <IllustrationModal project={modalProject} onClose={() => setModalProject(null)} />
      )}

      <Link to="/contact" className="float-contact" aria-label="Contact">
        Contact
      </Link>
    </PageLayout>
  );
}
